import { cancelable } from 'cancelable-promise';
export class PdfJsEmbeddedMediaSVGRendererImageExtractorService {
    constructor(pdfjsLib, pdfPage, media, BEST_MATCH_BOUNDS_PRECISION = 5) {
        this.htmlElement = null;
        this.className = 'sp-pdfjs-embedded-media-svg-renderer-image-extractor';
        this.pdfjsLib = pdfjsLib;
        this.pdfPage = pdfPage;
        this.media = media;
        this.BEST_MATCH_BOUNDS_PRECISION = BEST_MATCH_BOUNDS_PRECISION;
        this.htmlElement = document.createElement(`div`);
        this.htmlElement.className = this.className;
        this.htmlElement.style.cssText = `position: absolute; top: 0; left: 0; pointer-events: none; opacity: 0;`;
    }
    render() {
        if (this.renderPromise) {
            return this.renderPromise;
        }
        this.renderPromise = cancelable(new Promise(resolve => {
            this.pdfPage.getOperatorList().then(pdfPageOperatorList => {
                this.pdfPageOperatorList = pdfPageOperatorList;
                document.body.appendChild(this.htmlElement);
                const htmlElementRect = this.htmlElement.getBoundingClientRect();
                const svgGraphics = new this.pdfjsLib.SVGGraphics(this.pdfPage.commonObjs, this.pdfPage.objs);
                svgGraphics.getSVG(this.pdfPageOperatorList, this.pdfPage.getViewport({ scale: 1 })).then(svg => {
                    this.htmlElement.appendChild(svg);
                    const svgImages = [].slice.call(svg.querySelectorAll('image'));
                    const serial = funcs => funcs.reduce((promise, func) => promise.then(result => func().then(Array.prototype.concat.bind(result))), Promise.resolve([]));
                    const tasks = this.media.map((mediaItem) => () => {
                        return new Promise((resolve, reject) => {
                            const positionElement = document.createElement('div');
                            const positionContentElement = document.createElement('div');
                            const intersectionElement = document.createElement('div');
                            const arrangement = mediaItem.arrangement;
                            const size = arrangement.size;
                            const offset = arrangement.offset;
                            const mediaSize = mediaItem.size;
                            const crop = arrangement.crop;
                            positionElement.style.cssText = `position: absolute; top: 0; left: 0; width:${size.width}px; height:${size.height}px; transform: translate(${offset.x}px, ${offset.y}px) rotate(0deg);`;
                            let top = 0;
                            let left = 0;
                            let height = 100;
                            let width = 100;
                            if (crop) {
                                width =
                                    (mediaSize.width /
                                        (mediaSize.width -
                                            mediaSize.width * (crop.left / 100) -
                                            mediaSize.width * (crop.right / 100))) *
                                        100;
                                height =
                                    (mediaSize.height /
                                        (mediaSize.height -
                                            mediaSize.height * (crop.top / 100) -
                                            mediaSize.height * (crop.bottom / 100))) *
                                        100;
                                top = -((height * crop.top) / 100);
                                left = -((width * crop.left) / 100);
                            }
                            positionContentElement.style.cssText = `position: absolute; top:${top}%; left:${left}%; width:${width}%; height:${height}%;`;
                            positionElement.appendChild(positionContentElement);
                            this.htmlElement.appendChild(positionElement);
                            const positionRect = positionElement.getBoundingClientRect();
                            const positionContentRect = positionContentElement.getBoundingClientRect();
                            const positionContentIntersectionRect = this.intersection(positionRect, positionContentRect);
                            positionContentIntersectionRect.top -= offset.y;
                            positionContentIntersectionRect.left -= offset.x;
                            positionContentIntersectionRect.top -= htmlElementRect.top;
                            positionContentIntersectionRect.left -= htmlElementRect.left;
                            intersectionElement.style.cssText = `position: absolute; top:${positionContentIntersectionRect.top}px; left:${positionContentIntersectionRect.left}px; width:${positionContentIntersectionRect.width}px; height:${positionContentIntersectionRect.height}px; background:#0FF;`;
                            positionElement.appendChild(intersectionElement);
                            positionElement.style.cssText = `position: absolute; top: 0; left: 0; width:${size.width}px; height:${size.height}px; transform: translate(${offset.x}px, ${offset.y}px) rotate(${arrangement.rotation}deg);`;
                            const intersectionRect = intersectionElement.getBoundingClientRect();
                            let extractedImages = svgImages
                                .map((svgImage, svgImageIndex) => {
                                const svgImageRect = svgImage.getBoundingClientRect();
                                const xDiff = Math.abs(intersectionRect.left - svgImageRect.left);
                                const yDiff = Math.abs(intersectionRect.top - svgImageRect.top);
                                const wDiff = Math.abs(intersectionRect.width - svgImageRect.width);
                                const hDiff = Math.abs(intersectionRect.height - svgImageRect.height);
                                const boundsDiff = parseFloat((xDiff + yDiff + wDiff + hDiff).toFixed(1));
                                return {
                                    index: svgImageIndex,
                                    element: svgImage,
                                    boundsDiff: boundsDiff
                                };
                            })
                                .sort((imageA, imageB) => {
                                if (imageA.boundsDiff < imageB.boundsDiff) {
                                    return -1;
                                }
                                if (imageA.boundsDiff > imageB.boundsDiff) {
                                    return 1;
                                }
                                if (imageA.index < imageB.index) {
                                    return 1;
                                }
                                if (imageA.index > imageB.index) {
                                    return -1;
                                }
                                return 0;
                            })
                                .filter(image => image.boundsDiff <= this.BEST_MATCH_BOUNDS_PRECISION);
                            if (extractedImages.length > 1 && extractedImages[0].boundsDiff === extractedImages[1].boundsDiff) {
                                const tasks = extractedImages.map(extractedImage => () => {
                                    return new Promise((resolve, reject) => {
                                        const image = new Image();
                                        const canvas = document.createElement('canvas');
                                        const context = canvas.getContext('2d', {
                                            willReadFrequently: true
                                        });
                                        image.src = extractedImage.element.getAttribute('xlink:href');
                                        image.onload = () => {
                                            canvas.width = 50;
                                            canvas.height = 50;
                                            context.drawImage(image, 0, 0, canvas.width, canvas.height);
                                            const imageData = context.getImageData(0, 0, canvas.width, canvas.height).data;
                                            let transparency = false;
                                            for (let i = 0; i < imageData.length; i += 4) {
                                                if (imageData[i + 3] < 255) {
                                                    transparency = true;
                                                    break;
                                                }
                                            }
                                            extractedImage.transparency = transparency;
                                            this.htmlElement.appendChild(canvas);
                                            resolve(extractedImage);
                                        };
                                    });
                                });
                                serial(tasks).then(() => {
                                    extractedImages = extractedImages.filter(extractedImage => extractedImage.transparency === false);
                                    resolve(extractedImages[0] || null);
                                });
                            }
                            else {
                                resolve(extractedImages[0] || null);
                            }
                        });
                    });
                    serial(tasks).then(results => {
                        this.htmlElement.innerHTML = ``;
                        document.body.removeChild(this.htmlElement);
                        resolve(results);
                    });
                });
            });
        }));
        return this.renderPromise;
    }
    intersection(a, b) {
        const left = Math.max(a.left, b.left);
        const top = Math.max(a.top, b.top);
        const right = Math.min(a.right, b.right);
        const bottom = Math.min(a.bottom, b.bottom);
        const width = right - left;
        const height = bottom - top;
        return {
            left,
            top,
            right,
            bottom,
            width,
            height
        };
    }
    destroy() {
        if (this.renderPromise) {
            this.renderPromise.cancel();
            this.renderPromise = null;
        }
        if (this.htmlElement.parentNode) {
            this.htmlElement.parentNode.removeChild(this.htmlElement);
        }
        this.htmlElement.innerHTML = ``;
    }
}
//# sourceMappingURL=pdfjs-embedded-media-svg-renderer-image-extractor.service.js.map